<template>
    <div></div>
</template>

<script>
export default {
    mounted() {
        let freshworksWidget = document.createElement('script')
        freshworksWidget.setAttribute('src', 'https://widget.freshworks.com/widgets/4000000307.js')
        freshworksWidget.async = true
        freshworksWidget.defer = true
        document.head.appendChild(freshworksWidget)
        window.fwSettings = {'widget_id' : '4000000307' };
        !function() { 
            if("function"!=typeof window.FreshworksWidget) {
                var n = function() {
                        n.q.push(arguments)
                    };
                n.q = [],
                window.FreshworksWidget=n
            }
        }()

        // Hide the Contact us button
		
		window.FreshworksWidget('hide', 'launcher');
        
        // Hide the Group field

        window.FreshworksWidget('hide', 'ticketForm', ['group_id'])
        
         // Hide the Category field

        window.FreshworksWidget('hide', 'ticketForm', ['custom_fields.glory_support'])

        // Prefil the Category field

        window.FreshworksWidget('hide', 'ticketForm', ['custom_fields.glory_support']);


        // Prefill the Group field

        window.FreshworksWidget('prefill', 'ticketForm', {
            group_id: 4000012182,
        });
    },
}
</script>
